<fin-booking-plain-header-area [title]="'MMB.purchase.success.title' | finLocalization" />

@if ((orderStatus$ | async) === OrderStatus.OK) {
  <div>
    <fin-section-review
      data-testid="mmb-purchase-introduction-note"
      class="mr-xsmall-t"
      [title]="'MMB.purchase.success.introductionMessage.title' | finLocalization"
      [noButton]="true"
    >
      <ng-container ngProjectAs="content">
        <div class="ps-large-b">
          <p>{{ 'MMB.purchase.success.introductionMessage.sendEmdToEmails' | finLocalization }}</p>
          <ul class="ps-medium-x">
            @for (email of passengerEmails$ | async; track email) {
              <li class="medium-type lowercase">{{ email }}</li>
            }
          </ul>
        </div>

        <p>{{ 'MMB.purchase.success.introductionMessage.p2' | finLocalization }}</p>
      </ng-container>
    </fin-section-review>

    <fin-included-products
      class="block mr-xsmall-t"
      [booking]="order$ | async"
      [useCabinClass]="false"
      [titleTranslationKey]="'MMB.purchase.success.purchaseTravelExtras'"
      [showAdditionalTitle]="true"
      [expandOpen]="true"
      [servicesToShow]="services$ | async"
      [displaySeatReassignMessage]="true"
    />

    <fin-section-review
      class="mr-xsmall-t"
      [fullWidth]="true"
      [title]="'purchase.review.priceBreakdown' | finLocalization"
      [noButton]="true"
    >
      <ng-container ngProjectAs="content">
        @if ((pointsUsedToPay$ | async) === true) {
          <div data-testid="mmb-purchase-success-points-notification" class="pr-small-x pr-small-t fill">
            <fcom-notification>
              {{ 'purchase.success.pointsUsedToPay' | finLocalization }}
            </fcom-notification>
          </div>
        }
        <fin-price-breakdown
          class="flex--basis-full"
          [prices$]="prices$"
          [passengers$]="order$ | finMap: 'passengers'"
          [showBaseFare]="false"
          [showTotalTax]="false"
          [expandOpen]="true"
        />
      </ng-container>
    </fin-section-review>

    <fin-grand-total [prices$]="prices$" />

    @if (paymentMethods$ | async; as paymentMethods) {
      <fin-section-review
        class="mr-xsmall-t"
        [title]="'payment.paymentMethod.title' | finLocalization"
        [noButton]="true"
      >
        <ng-container ngProjectAs="content">
          @for (paymentMethod of paymentMethods; track paymentMethod.id) {
            <fin-payment-method [payment]="paymentMethod" class="flex--basis-full" />
          }
        </ng-container>
      </fin-section-review>
    }
    @if (showHotelsWidget$ | async) {
      <fin-mmb-hotels-widget
        class="block mr-xsmall-y"
        [order$]="order$"
        [placement]="ExpediaHotelOrigin.ANCILLARY_CONFIRMATION"
      />
    }

    @if (showCarTrawlerWidget$ | async) {
      <fin-cartrawler-widget [clientId]="carTrawlerClientId" [order]="order$ | async" extraClasses="mr-xsmall-y" />
    }

    @if (showTravelInsuranceBanner$ | async) {
      <fin-ancillary-cta-banner
        [title]="'MMB.allianz.purchaseSuccessBanner.title' | finLocalization"
        [mainText]="'MMB.allianz.purchaseSuccessBanner.mainText' | finLocalization"
        [buttonText]="'MMB.allianz.purchaseSuccessBanner.buttonText' | finLocalization"
        [href]="'MMB.allianz.purchaseSuccessBanner.href' | finLocalization"
        [customIconForLogo]="CustomIcon.ALLIANZ_LOGO"
        [imageData]="allianz24HourBannerImage$ | async"
        class="mr-xsmall-t block"
      />
    }
    @if (showActivitiesBanner()) {
      <fcom-activities-banner class="mr-xsmall-t block" />
    }
    <fin-section-review
      data-testid="mmb-purchase-success-feedback"
      class="mr-medium-t"
      [title]="'MMB.purchase.success.feedback.title' | finLocalization"
      [noButton]="true"
    >
      <ng-container ngProjectAs="content">
        <fcom-button [text]="'MMB.purchase.success.feedback.button' | finLocalization" (clickBtn)="openModal($event)" />
        <fin-qualtrics [survey]="survey" [(open)]="openSurvey" />
      </ng-container>
    </fin-section-review>
  </div>
} @else {
  <fin-bound-selection-error-message
    (ctaClick)="loadOrderErrorClick.emit(true)"
    [ctaButtonText]="'bookingSearch.tryAgain' | finLocalization"
  >
    <span class="title">{{ 'serverErrorCodes.loadOrderFailed' | finLocalization }}</span>
  </fin-bound-selection-error-message>
}

<div class="mr-small-y align-center">
  <fin-link [url]="ctaUrl" [text]="'MMB.purchase.success.cta' | finLocalization" />
</div>
